module.exports = __webpack_public_path__ + "static/media/search.679d16cf.svg";